module.exports = __webpack_public_path__ + "h5/img/love.a34a61fa.png";